<template>
  <div class="container">
    <Loading />

    <Header color="black" type="page" />
    <span
      class="default-banner"
      v-if="this.currStep === 1 || this.currImg === null"
    ></span>
    <div v-else class="image-wrapper" style="padding: 0">
      <img
        :src="currImg"
        class="banner-background"
        v-if="displayWidth >= 768"
      />
      <div style="width: 100vw; height: 10rem">
        <img
          :src="currImg"
          class="promo-banner"
          v-bind:style="{
            'object-fit': displayWidth >= 768 ? 'contain' : 'cover',
          }"
        />
      </div>
    </div>
    <span class="opt-in"></span>

    <div class="bottom">
      <Groups
        @advance="handleNext"
        @setImage="setImage"
        v-if="this.currStep === 1"
        :step="1"
        :groups="groups"
      />
      <Campaigns
        @setImage="setImage"
        @advance="handleNext"
        @load="loadCampaigns"
        v-if="this.currStep === 2"
        :step="2"
        :id.sync="groupID"
        :campaignID="campaignID"
        :campaigns="campaigns[groupID]"
      />
      <Offers
        @advance="handleNext"
        @showExpired="openExpiredModal"
        @load="loadOffers"
        v-if="this.currStep === 3"
        :step="3"
        :id="campaignID"
        :offers="offers[this.campaignID]"
        :selfOptin="selfOptin"
        :custSignup="custSignup"
      />
    </div>
    <b-modal v-model="showModal" @keyup.enter="closeModal" hide-footer centered>
      <div>
        <p>Sorry, this offer has expired.</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loading from "../components/Loading.vue";
import Header from "../components/Header";
import Groups from "../components/Groups";
import Campaigns from "../components/Campaigns";
import Offers from "../components/Offers";
import { LoadingStore } from "@/store/LoadingStore.js";

import axios from "axios";
//import { globalLogon } from '../router/internalRouter.js'

export default {
  name: "Promotions",
  components: {
    Loading,
    Header,
    Groups,
    Campaigns,
    Offers,
  },
  props: {
    currStepProp: Number,
    campaignIDProp: Number,
    selfOptinProp: Boolean,
    custSignupProp: Boolean,
  },
  data() {
    return {
      loadingStore: LoadingStore(),
      currImg: null,
      groups: null,
      currStep: null,
      groupID: null,
      campaignID: null,
      campaigns: {},
      offers: {},
      isLoading: true,
      loaderType: "page",
      displayWidth: 0,
      showModal: false,
    };
  },
  created() {
    this.campaignID = this.campaignIDProp;
    this.selfOptin = this.selfOptinProp;
    this.custSignup = this.custSignupProp;
    this.getGroups();
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    setImage(payload) {
      this.currImg = payload;
    },
    openExpiredModal(exp) {
      this.showModal = exp;
    },
    getGroups() {
      this.loadingStore.type = "page";
      this.loadingStore.isLoading = true;
      axios
        .get("admin/groups")
        .then((response) => {
          //Hide groups that aren't accessible ( not active not campaign creator or admin or not a valid cost center member)
          this.groups = response.data.filter(function (el) {
            return (
              el.active === 1 &&
              (el.member_access.valid_cost_center ||
                el.member_access.member_type.includes("ADMIN") ||
                el.member_access.member_type.includes("CAMPAIGN_CREATOR") ||
                el.member_access.campaign_user_perms.length > 0)
            );
          });

          // Determine step
          if (this.currStepProp == null) {
            //flow from beginning of form
            this.currStep = 1;
            this.selfOptin = null;
            this.custSignup = null;
            // if starting at groups page, use the 'form' loader from here on out
            this.loadingStore.type = "form";
          } else {
            this.selfOptin = this.selfOptinProp;
            this.custSignup = this.custSignupProp;
            //going back from selected offer to all offers
            this.currStep = this.currStepProp;
          }
        })
        .catch((error) => {
          console.error(error);
          // Auth and Cookie errors get caught by interceptor, other errors should route to error page
          setTimeout(() => {
            let errorMsg = error.response.data.UserMsgMap;
            this.$router.replace({ name: "error", params: { errorMsg } });
          }, 1000);
        })
        .finally(() => {
          if (
            !this.loadingStore.isCampaignsAsyncing &&
            !this.loadingStore.isOffersAsyncing
          ) {
            this.loadingStore.isLoading = false;
          }
        });
    },
    handleNext(event) {
      this.currStep = event[0];
      if (this.currStep === 2) {
        this.groupID = event[1] ? event[1] : this.groupID;

        if (this.groupID) {
          this.custSignup = null;
          this.selfOptin = null;
        }
      } else if (this.currStep === 3) {
        this.campaignID = event[1] ? event[1] : this.campaignID;

        const selectedCampaign = this.campaigns[this.groupID].filter((el) => {
          return el.campaign_id === this.campaignID;
        });
        // if admin/application admin or campaign creator let them set perms according to campaign CC types (I.E All Cost Center types Perms available)
        if (
          selectedCampaign[0].access.member_type.includes("ADMIN") ||
          selectedCampaign[0].access.member_type === "CAMPAIGN_CREATOR"
        ) {
          this.selfOptin = selectedCampaign[0].cost_center_types.includes(
            "CUSTOMER_SELF_OPT_IN"
          ) || selectedCampaign[0].campaign_user_types.includes(
              "CUSTOMER_SELF_OPT_IN");
          this.custSignup =
            selectedCampaign[0].cost_center_types.includes("CUSTOMER_SIGN_UP") || selectedCampaign[0].campaign_user_types.includes(
              "CUSTOMER_SIGN_UP");
        } else {
          // for other members set CC Perms according access
          this.selfOptin =
            selectedCampaign[0].access.cost_center_perms.includes(
              "CUSTOMER_SELF_OPT_IN"
            ) ||
            selectedCampaign[0].access.campaign_user_perms.includes(
              "CUSTOMER_SELF_OPT_IN"
            );

          this.custSignup =
            selectedCampaign[0].access.cost_center_perms.includes(
              "CUSTOMER_SIGN_UP"
            ) ||
            selectedCampaign[0].access.campaign_user_perms.includes(
              "CUSTOMER_SIGN_UP"
            );
        }
      } else {
        this.custSignup = null;
        this.selfOptin = null;
      }
    },
    loadCampaigns(event) {
      this.campaigns[this.groupID] = event;
    },
    loadOffers(event) {
      this.offers[this.campaignID] = event;
    },
    onResize() {
      this.displayWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.container > header,
.container > div {
  flex: 1;
  padding: 2.5vh 5vw;
}

.promo-banner {
  height: 10rem;
  width: 100%;
}

.default-banner {
  height: 10rem;
  width: 100%;
  background: url("../assets/landing.jpg") no-repeat;
  background-size: cover;
}

.opt-in {
  background: #229bd8;
  color: #fff;
  height: 3vh;
}

.bottom {
  background: #e8e8e8;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 66vh;
}

.image-wrapper {
  position: relative;
  display: table;
  max-height: 10rem;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.1);
}

.banner-background {
  -o-object-fit: cover;
  object-fit: cover;
  -webkit-filter: blur(2px);
  filter: blur(5px);
  position: absolute;
  top: calc(50% + 8px);
  left: 50vw;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: calc(100vw + 16px);
  height: 11rem;
  z-index: -1;
  margin: -4px;
}
</style>
